import clsx from 'clsx'
import { MapboxMobilePositionsContext } from 'components/MapboxMap/MapboxCommon'
import { useIsMobile } from 'hooks/useIsMobile'
import { useContext } from 'react'

import style from './CenterOnRobotButton.module.css'

const CenterOnRobotButton = ({
  onClick,
  right,
  disabled,
}: {
  onClick: () => void
  right?: number
  disabled?: boolean
}) => {
  const isMobile = useIsMobile()
  const positions = useContext(MapboxMobilePositionsContext)
  const rightPos = right ?? positions.extra1

  return (
    <div
      className={style.root}
      onClick={!disabled ? onClick : undefined}
      style={isMobile && rightPos !== undefined ? { right: rightPos } : {}}
    >
      <button className={style.button} disabled={disabled} title="Center on robot">
        <span className={clsx('mapboxgl-ctrl-icon', style.icon)} />
      </button>
    </div>
  )
}

export default CenterOnRobotButton
